"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdServingOptimizationStatus = void 0;
var AdServingOptimizationStatus;
(function (AdServingOptimizationStatus) {
    AdServingOptimizationStatus[AdServingOptimizationStatus["OPTIMIZE"] = 0] = "OPTIMIZE";
    AdServingOptimizationStatus[AdServingOptimizationStatus["CONVERSION_OPTIMIZE"] = 1] = "CONVERSION_OPTIMIZE";
    AdServingOptimizationStatus[AdServingOptimizationStatus["ROTATE"] = 2] = "ROTATE";
    AdServingOptimizationStatus[AdServingOptimizationStatus["ROTATE_INDEFINITELY"] = 3] = "ROTATE_INDEFINITELY";
    AdServingOptimizationStatus[AdServingOptimizationStatus["UNAVAILABLE"] = 4] = "UNAVAILABLE";
    AdServingOptimizationStatus[AdServingOptimizationStatus["UNKNOWN"] = 5] = "UNKNOWN";
})(AdServingOptimizationStatus || (exports.AdServingOptimizationStatus = AdServingOptimizationStatus = {}));
//# sourceMappingURL=AdServingOptimizationStatus.js.map